import styled from 'styled-components'
import media from 'styled-media-query'

export const Container = styled.div`
  position: relative;
  background: linear-gradient(135deg, #0046a8 0%, #00a1ff 100%);
  height: 400px;
  border-radius: 24px;
  margin-bottom: 50px;
  margin-top: 20px;
  overflow: hidden;
  box-shadow: 0 16px 40px rgba(0, 124, 255, 0.2);
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    position: absolute;
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    top: -100px;
    right: -50px;
  }
  
  &::after {
    content: '';
    position: absolute;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    bottom: -50px;
    left: 10%;
  }

  ${media.lessThan('medium')`
    height: 300px;
    margin-top: 10px;
    margin-bottom: 30px;
  `}
`

export const HeroContent = styled.div`
  position: relative;
  z-index: 2;
  padding-left: 60px;
  max-width: 60%;

  h1 {
    color: white;
    margin-bottom: 30px;
    font-size: 46px;
    line-height: 1.2;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    
    b {
      font-weight: 900;
    }
    
    span {
      font-weight: 300;
      font-size: 22px;
      opacity: 0.9;
    }
  }

  ${media.lessThan('medium')`
    padding-left: 30px;
    max-width: 100%;
    
    h1 {
      font-size: 28px;
      margin-bottom: 20px;
      
      span {
        font-size: 18px;
      }
    }
  `}
`

export const CTAButton = styled.a`
  display: inline-block;
  background: white;
  color: #0062cc;
  font-weight: 600;
  padding: 14px 28px;
  border-radius: 50px;
  font-size: 16px;
  text-decoration: none;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    color: #0062cc;
    text-decoration: none;
  }

  ${media.lessThan('medium')`
    padding: 10px 20px;
    font-size: 14px;
  `}
`
export const ImageWrapper = styled.div`
  position: absolute;
  top: calc(20% - 50px); /* Moved up 50px */
  right: 60px;
  transform: translateY(50%) translateZ(0);
  width: 800px;
  height: 500px;
  background-image: url(${require('../../assets/images/server-hub-3.png')});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
  transition: all 0.3s ease;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: inherit;
    background-size: inherit;
    background-repeat: inherit;
    background-position: inherit;
    animation: gentleSway 6s ease-in-out infinite;
  }
  
  @keyframes gentleSway {
    0% { transform: rotate(0deg); }
    25% { transform: rotate(0.3deg); }
    50% { transform: rotate(0deg); }
    75% { transform: rotate(-0.3deg); }
    100% { transform: rotate(0deg); }
  }

  &:hover::after {
    animation-play-state: paused;
    filter: brightness(1.1);
  }

  &:hover {
    transform: translateY(50%) translateZ(20px) scale(1.02);
  }

  ${media.lessThan('large')`
    width: 900px;
    height: 500px;
    right: 30px;
  `}

  ${media.lessThan('medium')`
    opacity: 0.3;
    width: 200px;
    height: 200px;
    right: 10px;
  `}
`
